import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import {
  grayColor,
  blendColors,
} from "assets/jss/material-dashboard-pro-react";

const useStyles = makeStyles(() => ({
  triggerButton: {
    position: "fixed",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1100,
    color: "#fff",
    border: "none",
    padding: "12px 2px 4px 2px",
    borderRadius: "8px 0 0 8px",
    cursor: "pointer",
    boxShadow: "-2px 2px 8px rgba(0,0,0,0.15)",
    transition: "all 0.2s ease",
    "&:hover": {
      paddingLeft: "6px",
      paddingRight: "10px",
    },
  },
  triggerButtonInner: {
    writingMode: "vertical-rl",
    textOrientation: "mixed",
    transform: "rotate(180deg)",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "13px",
    fontWeight: 400,
    whiteSpace: "nowrap",
    lineHeight: "1.1",
    // letterSpacing: "1.5px !important",
  },
  icon: {
    fontSize: "13px",
  },
}));

export default function AIChatButton({ onClick, clientColor }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const bgStyle = useMemo(() => {
    const base = grayColor[6];
    const blended = clientColor ? blendColors(base, clientColor, 0.7) : base;
    return { background: `linear-gradient(15deg, ${base}, ${blended})` };
  }, [clientColor]);

  return (
    <div
      className={classes.triggerButton}
      style={bgStyle}
      onClick={onClick}
      title={t("ai_chat.button_tooltip", {
        defaultValue: "Abrir asistente de análisis",
      })}
    >
      <span className={classes.triggerButtonInner}>
        <span className={classes.icon}>✦</span>
        {t("ai_chat.button_text", { defaultValue: "Asistente IA" })}
      </span>
    </div>
  );
}

AIChatButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  clientColor: PropTypes.string,
};
